import React from 'react';
import { Typography, Card, Row, Col, Button, Space, Divider } from 'antd';
import { CrownOutlined, GiftOutlined, CheckCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const Billing = () => (
  <div style={{ maxWidth: 1000, margin: '20px auto', padding: '0 16px' }}>
    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
      <Title level={2}>付费条款</Title>
      <Text style={{ color: '#666' }}>最后更新时间：2025年10月21日</Text>
    </div>

    {/* 会员套餐 */}
    <Card style={{ marginBottom: '40px' }}>
      <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
        <CrownOutlined style={{ marginRight: '8px', color: '#fa8c16' }} />
        会员套餐
      </Title>
      <Row gutter={[24, 24]}>
        <Col xs={24} md={8}>
          <Card style={{ textAlign: 'center', height: '300px' }}>
            <Title level={4}>普通会员</Title>
            <Text style={{ fontSize: '32px', color: '#1890ff', fontWeight: 'bold' }}>
              免费
            </Text>
            <br /><br />
            <div style={{ textAlign: 'left' }}>
              <Text>✅ 基础功能使用</Text><br />
              <Text>✅ 文件管理</Text><br />
              <Text>✅ 物品管理</Text><br />
              <Text>✅ 资金管理</Text><br />
              <Text>✅ 时间管理</Text><br />
              <Text>✅ 数据云端同步</Text><br />
              <Text>✅ 基础客服支持</Text>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card style={{ 
            textAlign: 'center', 
            height: '300px', 
            border: '2px solid #52c41a',
            position: 'relative'
          }}>
            <div style={{ 
              position: 'absolute', 
              top: '-10px', 
              left: '50%', 
              transform: 'translateX(-50%)',
              background: '#52c41a',
              color: 'white',
              padding: '4px 16px',
              borderRadius: '12px',
              fontSize: '12px'
            }}>
              推荐
            </div>
            <Title level={4}>高级会员</Title>
            <Text style={{ fontSize: '32px', color: '#52c41a', fontWeight: 'bold' }}>
              98元/年
            </Text>
            <br /><br />
            <div style={{ textAlign: 'left' }}>
              <Text>✅ 普通会员所有功能</Text><br />
              <Text>✅ 解锁全部20个模块</Text><br />
              <Text>✅ 高级功能使用</Text><br />
              <Text>✅ 优先客服支持</Text><br />
              <Text>✅ 数据备份服务</Text><br />
              <Text>✅ 推荐分享奖励</Text><br />
              <Text>✅ 专属客服群</Text>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card style={{ textAlign: 'center', height: '300px' }}>
            <Title level={4}>VIP会员</Title>
            <Text style={{ fontSize: '32px', color: '#fa8c16', fontWeight: 'bold' }}>
              198元/年
            </Text>
            <br /><br />
            <div style={{ textAlign: 'left' }}>
              <Text>✅ 高级会员所有功能</Text><br />
              <Text>✅ 所有功能无限制</Text><br />
              <Text>✅ 专属客服支持</Text><br />
              <Text>✅ 定制化服务</Text><br />
              <Text>✅ API接口访问</Text><br />
              <Text>✅ 企业级功能</Text><br />
              <Text>✅ 优先新功能体验</Text>
            </div>
          </Card>
        </Col>
      </Row>
    </Card>

    {/* 支付方式 */}
    <Card style={{ marginBottom: '40px' }}>
      <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
        支付方式
      </Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Card style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>💳</div>
            <Text strong>微信支付</Text><br />
            <Text style={{ color: '#666', fontSize: '12px' }}>支持微信扫码支付</Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>📱</div>
            <Text strong>小程序支付</Text><br />
            <Text style={{ color: '#666', fontSize: '12px' }}>微信小程序内支付</Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>🎫</div>
            <Text strong>激活码</Text><br />
            <Text style={{ color: '#666', fontSize: '12px' }}>购买激活码充值</Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>📲</div>
            <Text strong>APP支付</Text><br />
            <Text style={{ color: '#666', fontSize: '12px' }}>移动APP内支付</Text>
          </Card>
        </Col>
      </Row>
    </Card>

    {/* 推荐奖励 */}
    <Card style={{ marginBottom: '40px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div style={{ textAlign: 'center', color: 'white' }}>
        <GiftOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
        <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
          推荐奖励计划
        </Title>
        <Paragraph style={{ color: 'white', fontSize: '16px', marginBottom: '20px' }}>
          邀请好友注册使用管理师，获得积分奖励，积分可用于兑换会员权益
        </Paragraph>
        <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
          <Col xs={24} sm={8}>
            <Text style={{ color: 'white', fontSize: '18px' }}>
              推荐注册：+1积分
            </Text>
          </Col>
          <Col xs={24} sm={8}>
            <Text style={{ color: 'white', fontSize: '18px' }}>
              推荐高级会员：+2积分
            </Text>
          </Col>
          <Col xs={24} sm={8}>
            <Text style={{ color: 'white', fontSize: '18px' }}>
              推荐VIP会员：+3积分
            </Text>
          </Col>
        </Row>
      </div>
    </Card>

    {/* 退款政策 */}
    <Card style={{ marginBottom: '40px' }}>
      <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
        <QuestionCircleOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
        退款政策
      </Title>
      <Row gutter={[24, 24]}>
        <Col xs={24} md={12}>
          <Title level={4}>不支持退款的情况</Title>
          <ul>
            <li>会员服务为数字商品，开通后立即生效</li>
            <li>已正常使用会员功能</li>
            <li>因个人原因不需要继续使用</li>
            <li>违反用户协议被终止服务</li>
          </ul>
        </Col>
        <Col xs={24} md={12}>
          <Title level={4}>支持退款的情况</Title>
          <ul>
            <li>重复扣费（提供支付凭证）</li>
            <li>服务存在重大技术问题</li>
            <li>未按承诺提供服务</li>
            <li>法律法规规定的其他情形</li>
          </ul>
        </Col>
      </Row>
      <Divider />
      <div style={{ textAlign: 'center' }}>
        <Text style={{ color: '#666' }}>
          如需申请退款，请联系客服：support@manage.net.cn
        </Text>
      </div>
    </Card>

    {/* 常见问题 */}
    <Card style={{ marginBottom: '40px' }}>
      <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
        常见问题
      </Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Title level={5}>Q: 如何购买会员？</Title>
          <Text>
            A: 登录后在个人中心点击"卡密商城"，选择相应的会员套餐进行购买。
          </Text>
        </Col>
        <Col xs={24} md={12}>
          <Title level={5}>Q: 会员有效期多长？</Title>
          <Text>
            A: 高级会员和VIP会员的有效期均为1年，从开通之日起计算。
          </Text>
        </Col>
        <Col xs={24} md={12}>
          <Title level={5}>Q: 可以中途升级会员吗？</Title>
          <Text>
            A: 可以，升级时按剩余时间比例计算差价。
          </Text>
        </Col>
        <Col xs={24} md={12}>
          <Title level={5}>Q: 会员到期后数据会丢失吗？</Title>
          <Text>
            A: 不会，数据会保留30天，续费后可继续使用。
          </Text>
        </Col>
        <Col xs={24} md={12}>
          <Title level={5}>Q: 支持哪些支付方式？</Title>
          <Text>
            A: 支持微信支付、小程序支付、激活码等多种支付方式。
          </Text>
        </Col>
        <Col xs={24} md={12}>
          <Title level={5}>Q: 如何获得推荐奖励？</Title>
          <Text>
            A: 在个人中心点击"一键分享"，将推荐链接分享给好友即可。
          </Text>
        </Col>
      </Row>
    </Card>

    {/* 服务保障 */}
    <Card>
      <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
        <CheckCircleOutlined style={{ marginRight: '8px', color: '#52c41a' }} />
        服务保障
      </Title>
      <Row gutter={[24, 24]}>
        <Col xs={24} md={8}>
          <div style={{ textAlign: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: '32px', color: '#52c41a', marginBottom: '12px' }} />
            <Title level={5}>安全支付</Title>
            <Text style={{ color: '#666' }}>
              采用HTTPS加密传输，确保支付安全
            </Text>
          </div>
        </Col>
        <Col xs={24} md={8}>
          <div style={{ textAlign: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: '32px', color: '#52c41a', marginBottom: '12px' }} />
            <Title level={5}>即时开通</Title>
            <Text style={{ color: '#666' }}>
              支付成功后立即开通会员权益
            </Text>
          </div>
        </Col>
        <Col xs={24} md={8}>
          <div style={{ textAlign: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: '32px', color: '#52c41a', marginBottom: '12px' }} />
            <Title level={5}>客服支持</Title>
            <Text style={{ color: '#666' }}>
              7×24小时在线客服支持
            </Text>
          </div>
        </Col>
      </Row>
    </Card>

    {/* 版权信息 */}
    <div style={{ textAlign: 'center', marginTop: '40px', padding: '20px', background: '#f5f5f5', borderRadius: '8px' }}>
      <Text style={{ color: '#999' }}>
        © 2025 漳浦声语文化传媒有限公司 版权所有 | 
        <a href="/terms" style={{ margin: '0 8px' }}>用户协议</a> | 
        <a href="/privacy" style={{ margin: '0 8px' }}>隐私政策</a> | 
        <a href="/contact" style={{ margin: '0 8px' }}>联系我们</a>
      </Text>
    </div>
  </div>
);

export default Billing;
